import BaseField from './BaseField';
import RichTextWidget from '../widgets/RichTextWidget';

export default class RichTextField extends BaseField {
  widget = RichTextWidget;
}
